export const userInfoSelector = (state: any) => state.user.userInfo;
